import * as types from '../constants/actionTypes'
import * as axios from 'axios';
import config from '../config';
import { addNotification } from './notificationActions';
// const websocketUrl = config.socketserver.url + ':' + config.server.port;

export function getStreamsSuccess(streams) {
  return {
    type: types.GET_STREAMS,
    streams: streams
  };
}
export function getStreamSuccess(container) {
  return {
    type: types.GET_STREAM,
    container: container
};
}
export function getStreamsFailure(error) {
  return {
    type: types.GET_STREAMS,
    error: error
  };
}


export function saveNewStreamSuccess(containerId) {
    return {
      type: types.SAVE_NEW_STREAM,
      message: containerId
  };
}
export function saveNewStreamFailure(error) {
    return {
      type: types.SAVE_NEW_STREAM,
      error: error
  };
}

export function execConfigActionSuccess(data) {
  return {
    type: types.GET_CONFIG_ACTION,
    payload: {
      ...data
    }
  };
}

export function saveNewStream(options, serviceUrl){
  const url = serviceUrl + '/stream';
  return function(dispatch){
    dispatch(execConfigActionSuccess({validationError: false}));
    return axios.post(url, options, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(res => {
        dispatch(addNotification(res.data, 'success'));
        dispatch(saveNewStreamSuccess(res));
      })
      .catch(err => {
        let errData = err.response.data ? err.response.data : err;
        let notificationMessage = errData.message ? errData.message : errData;
        if(errData.fields) {
          dispatch(saveNewStreamFailure(errData))
          dispatch(addNotification(errData.message, 'error'))
        } else {
          dispatch(addNotification(notificationMessage, 'error'))
          dispatch(saveNewStreamFailure(err))
        }
      });
  }
}

export function getStream(containerId, serviceUrl){
  return function(dispatch){
    const url = `${serviceUrl}/stream/${containerId}`;
    return axios.get(url, {headers: {'Access-Control-Allow-Origin': '*'}})
      .then(() => {
        // dispatch(startStreamSuccess(res.data));
        dispatch(getStreamSuccess());
      })
      .catch(err => {
        dispatch(addNotification(err.message, 'error'));
      }
    );
  }
}

